/* Affiche la couleur choisie à côté de « Couleur » sur la page produit (ex. « Couleur : Lavande »). */
(() => {
  const sync = () => {
    document.querySelectorAll('fieldset.variant-option').forEach((fieldset) => {
      const checked = fieldset.querySelector("input[data-option-name='Couleur']:checked");
      const legend = fieldset.querySelector('legend');
      if (!checked || !legend) return;
      let value = legend.querySelector('.oto-legend-value');
      if (!value) {
        value = document.createElement('span');
        value.className = 'oto-legend-value';
        legend.append(value);
      }
      const text = ` : ${checked.value}`;
      if (value.textContent !== text) value.textContent = text;
    });
  };
  document.addEventListener('change', sync);
  new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true });
  sync();
})();
